export const UI_KEYS = {
  ENROLLED_TAB: 'enrolled_tab',
  COURSES_TAB: 'courses_tab',
  ICON_ENROLLED_TAB: 'icon_enrolled_tab',
  ICON_COURSES_TAB: 'icon_courses_tab',
  STATS_GOAL: 'stats_goal',
  STATS_PROGRESS: 'stats_progress',
  STATS_STREAK: 'stats_streak',
  STATS_GET_MOTIVATED: 'stats_get_motivated',
  STATS_LEADER_BOARD: 'stats_leader_board',
  STATS_ACTIVITY_STATS: 'stats_activity_stats',
  STATS_FOCUS_SUMMARY: 'stats_focus_summary',
  STATS_PRODUCTIVITY: 'stats_productivity',
  STATS_NOTES: 'stats_notes',
  PLAYER_TAB: 'player_tab',
  TODO_LIST_TAB: 'todo_list_tab'
};

export const TAB_INDEX = {
  DEFAULT: 0,
  PROGRAMMATIC: -1
};
